/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CCPaymentRetrieveTerminalSaleRequest = {
    properties: {
        districtId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        pendingPaymentTransactionId: {
            type: 'string',
            format: 'uuid',
        },
        channel: {
            type: 'PaymentChannel',
        },
    },
};